<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- System settings page -->
<template>
  <div class="system-settings page">
    <section class="page-section wrap">
      <appointment-scheduler></appointment-scheduler>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppointmentScheduler from '../components/AppointmentScheduler.vue'

export default defineComponent({
  name: 'System Settings',

  components: {
    AppointmentScheduler
  }
})
</script>

<style scoped lang="scss">
.wrap {
  max-width: 800px;
  margin: auto;
}
</style>
